import { Skeleton } from "@mantine/core";
import ContractorsComponent from "components/contractors/list";
import { SpecialistsPageConfig } from "config/routeConfig";
import useIsVisible from "hooks/useIsVisible";
import { useGetContractors } from "hooks/useRequest/contractors/contractors";
import dynamic from "next/dynamic";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import abTestService from "services/ab-test.service";
import lastProject from "services/last-project";
import initializeFilters from "utils/init-filters";
import styles from "../index.module.scss";

const InstallmentsPoster = dynamic(() => import('components/contractors/installments-poster'), {
  ssr: false,
  loading: () => <Skeleton animate w='100%' h={300} radius={16} />
});
const Filters = dynamic(() => import("components/contractors/filters"), {
  ssr: false,
  loading: () => <Skeleton animate w='100%' h={70} />
});
const GetPrice = dynamic(() => import("components/contractors/get-price"), {
  ssr: false,
  loading: () => <Skeleton animate w='100%' h={300} radius={16} />
});
const FloatingAction = dynamic(() => import('components/contractors/list/floating-action'));





export default function Contractors({ city }) {


  const router = useRouter();

  const [title, setTitle] = useState(null);
  const [metaDescription, setMetaDescription] = useState(null);

  const getPriceRef = useRef(null)

  const getPriceIntersection = useIsVisible(getPriceRef, {
    threshold: 0.2
  })

  const [visibleGetPrice, setVisibleGetPrice] = useState<boolean>(true)
  const [filters] = useState(initializeFilters)


  const contractors = useGetContractors({
    params: {
      limit: 9,
      ...((router.isReady && router.query?.city) && {
        cityAlias: router.query?.city as string,
      }),
      ...(router.query.workInInstallments && {
        workInInstallments: false
      })
    },
    options: {
      enabled: Boolean(router.isReady && router.query?.city)
    }
  });

  const {
    data,
    isSuccess,
  } = contractors


  useEffect(() => {
    if (isSuccess) {
      setMetaDescription(
        data.pages?.find((res) => res.meta.contractorPageMetaDescription)?.meta
          .contractorPageMetaDescription
      );
      setTitle(
        data.pages?.find((res) => res.meta.contractorPageTitle)?.meta
          .contractorPageTitle
      );
    }
  }, [isSuccess, data]);

  useEffect(() => {
    if (filters?.isDesigner) {
      setVisibleGetPrice(false)
    }
  }, [filters])





  return (
    <>
      <Head>
        <title>{title ?? "بازار آنلاین کابینت و دکوراسیون داخلی"}</title>
        <meta
          name="description"
          key="description"
          content={
            metaDescription ??
            "بزرگترین بازار آنلاین طراحی و سفارش انواع کابینت و کمد دیواری، معرفی بهترین کابینت سازها در سراسر ایران، تضمین کیفیت و قیمت"
          }
        />
        <link
          rel="canonical"
          href={"https://salamsakhteman.com" + router.pathname.replace("[city]", city)}
          key="canonical"
        />
      </Head>

      <section className="container pt-lg">
        {
          (router.query?.mode === "installments" || (abTestService.includesInstallmentUser() || router.query?.activeModal)) ?
            <InstallmentsPoster />
            :
            (router.query?.mode === "filters" || (lastProject.getId())) ?
              <>
                {title &&
                  <div className={styles.header + " pt-sm"}>
                    <h1 className={styles.title__header}>{title}</h1>
                    <h6 className={styles.caption__header}>
                      از لیست زیر نمونه‌کارها و نظرات هر متخصص را ببینید، متخصص انتخاب کنید وقرار بازدید بگذارید
                    </h6>
                  </div>
                }

                <Filters />

              </>
              : visibleGetPrice ?
                <>
                  <section ref={getPriceRef}>
                    <GetPrice />
                  </section>
                  <FloatingAction isVisible={!getPriceIntersection} />
                </>
                : <></>
        }
      </section>

      <ContractorsComponent
        {...contractors}
      />
    </>
  );
}


export async function getServerSideProps(params) {

  const { query } = await params

  return {
    props: {
      city: query.city,
    },
  };
}






Contractors.config = SpecialistsPageConfig;
